import BaseMaps from './BaseMaps'

export default BaseMaps
